import { render, staticRenderFns } from "./EVModelEditDetails.vue?vue&type=template&id=2aca9b22&scoped=true"
import script from "./EVModelEditDetails.vue?vue&type=script&lang=js"
export * from "./EVModelEditDetails.vue?vue&type=script&lang=js"
import style0 from "./EVModelEditDetails.vue?vue&type=style&index=0&id=2aca9b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca9b22",
  null
  
)

export default component.exports